import { HTMLTERM } from "./Termo-de-Uso-e-Privacidade-de-Dados-Axyma-converted";
import { useEffect } from 'react';
import { trackEventMatomoVisit } from '../helpers/matomo';


export default function PrivacyTerms() {
  useEffect(() => {
    trackEventMatomoVisit('Termos de privacidade');
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: HTMLTERM }} style={{ padding: '10px' }}/>
  );
}
